import React from "react";

import { useTheme } from "../../../context/ThemeContext";
import { addTrailingSlash } from "../../../utils/commonFunctions";
import InterestedArticles from "../../shared/interestedArticles";

const InterestedArticlesSection = ({ posts }) => {
  const { planetDomain } = useTheme();

  const relatedPosts =
    posts?.map((post) => ({
      title: post?.blogPosts?.featuredTitle ?? post?.title,
      caption: post?.blogPosts?.subTitle ?? "",
      description: post?.blogPosts?.blurb ?? "",
      views: "",
      featureImg: {
        gatsbyImage: post?.globalConfig?.backgroundImage?.gatsbyImage ?? null,
        localFile: post?.globalConfig?.backgroundImage?.localFile ?? null,
        sourceUrl: post?.globalConfig?.backgroundImage?.sourceUrl ?? null
      },
      thumbImg: {
        gatsbyImage:
          post?.blogPosts?.blogInsetImage?.gatsbyImage ??
          post?.globalConfig?.backgroundImage?.gatsbyImage ??
          null,
        localFile:
          post?.blogPosts?.blogInsetImage?.localFile ??
          post?.globalConfig?.backgroundImage?.localFile ??
          null,
        sourceUrl:
          post?.blogPosts?.blogInsetImage?.sourceUrl ??
          post?.globalConfig?.backgroundImage?.sourceUrl ??
          null
      },
      category: post?.focuses?.nodes?.pop() ?? "",
      slug: addTrailingSlash([(planetDomain, post?.uri)].join(""))
    })) ?? [];

  return (
    <section className="relative w-screen px-4 pt-24 pb-16 pr-0 bg-no-repeat bg-cover sm:pr-4 md:px-0 dark:text-white bg-generic-bg dark:bg-transparent">
      <div className="relative block w-full mx-auto sm:w-10/12">
        <h1 className="font-light dark:text-white">
          You might also like these articles
        </h1>
        <InterestedArticles
          posts={relatedPosts}
          showMiniImg={false}
          enableLink={true}
        />
      </div>
    </section>
  );
};

export default InterestedArticlesSection;
